import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './FloatingActionButton.styles';
const FloatingActionButton = ({ children, mode = 'button', showIcon = false, theme = 'white', ...props }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: mode, "data-theme": theme, "data-has-icon": showIcon, ...props },
            React.createElement(S.Text, null, children),
            showIcon && React.createElement(SvgClose, null))));
};
export default FloatingActionButton;
